<script lang="ts">
  import Lazy from 'svelte-lazy';
  import { PUBLIC_STRAPI_MEDIA } from '$env/static/public';
  import { is_set_array } from '$lib/js/helpers';
  import type { ColsBannerComponent } from "$lib/js/strapi/types";

  export let component: ColsBannerComponent
</script>


<div class="cols-banner">
  <div class="cols-banner__inner">

    {#if component.title && component.content}
      <div class="cols-banner__block">
        <h2>{component.title}</h2>
        <div class="cols-banner__description">
          {@html component.content}
        </div>

        {#if is_set_array(component.images)}
          <div class="cols-banner__images">
            {#each component.images as image}
              <Lazy height={100}>
                <img src="{PUBLIC_STRAPI_MEDIA}{image.url}" alt="{component.title}"
                     title="{component.title}">
              </Lazy>
            {/each}
          </div>
        {/if}
      </div>
    {/if}

    {#if component.title2 && component.content2}
      <div class="cols-banner__block">
        <h2>{component.title2}</h2>
        <div class="cols-banner__description">
          {@html component.content2}
        </div>

        {#if is_set_array(component.images2)}
          <div class="cols-banner__images">
            {#each component.images2 as image}
              <Lazy height={100}>
                <img src="{PUBLIC_STRAPI_MEDIA}{image.url}" alt="{component.title}"
                     title="{component.title}">
              </Lazy>
            {/each}
          </div>
        {/if}
      </div>
    {/if}

  </div>
</div>


<style lang="scss">
  .cols-banner {
    &__inner {
      @media (min-width: 769px) {
        display: flex;
        justify-content: space-between;
      }

      h2 {
        margin-right: 50px;
      }
    }

    &__block {
      position: relative;
      padding: 25px;
      background: var(--grey);
      color: black;
      margin: 0 0 20px;
      width: calc(100% - 50px);

      @media (min-width: 769px) {
        width: calc(50% - 60px);
        font-size: 16px;
      }

      img {
        height: 50px;
        width: 120px;
        object-fit: contain;
        margin: 15px 10px;

        &:first-child {
          margin-left: 0;
        }
      }
    }

    &__images {
      display: flex;
    }
  }
</style>
